import { render, staticRenderFns } from "./RedirectView.vue?vue&type=template&id=78f1a6a6&scoped=true"
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=78f1a6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f1a6a6",
  null
  
)

export default component.exports